module.exports = __webpack_public_path__ + "r-v3/img/ml_58_00_over.d3c27d0f.jpg";